import { toast } from "react-toastify";
import CommonUtil from "utils/CommonUtil";

import { RequestCode } from "../store/CodeDataStore";

/**
 * 코드데이터 RestRepository
 */
const codeDataRestRepository = new (class CodeDataRestRepository {

  /**
   * Map 조회
   *
   * @param requestCodeList
   */
  public async getMap(requestCodeList: RequestCode[]): Promise<any> {
    return await CommonUtil.execute({
      url:'com_code',
      data: {
        REC: requestCodeList
      }
    }).then((response:any) => {
      return response.CODE;
    }).catch((error) => {
      toast.error("CodeData Read Fail.");
    });
  }
})();

export default codeDataRestRepository;
